import { render, staticRenderFns } from "./WH_HandoverReport.vue?vue&type=template&id=6e9ff8a4"
import script from "./WH_HandoverReport.vue?vue&type=script&lang=js"
export * from "./WH_HandoverReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports